module.exports = __webpack_public_path__ + "assets/discount_active-0de3b9.svg";